import React, { useEffect, useState } from 'react';
import HeaderSCI from './HeaderSCI';
import './controlinterno.css';

const principios = [
  {
    id: 10,
    color: '#621132',
    title: "Principio 10. - Diseñar Actividades de Control.",
    items: [
       // { label: "Programa de Trabajo de Administración de Riesgos (PTAR).", url: "/micro/principio7/PTAR 2026 PRESENTAR.pdf" },
      // "Control de Procesos.",
      // "Funciones Procesos Sustantivos.",
      // "Funciones Procesos Adjetivos.",
      // "Manual de Remuneraciones",
      // "Políticas y Lineamientos que Aseguran que las Transacciones y Operaciones de los Ingresos y Egresos, Cumplan con la Normatividad Aplicable"
    ]
  },
  {
    id: 11,
    color: '#9e2348',
    title: "Principio 11. - Diseñar Actividades para los Sistemas de Información.",
    items: [
        // { label: "Programa de Trabajo de Administración de Riesgos (PTAR).", url: "/micro/principio7/PTAR 2026 PRESENTAR.pdf" },
      // "Lineamientos para el uso de las Tecnologias de la Información y Comunicación.",
      // "Sistemas y aplicativos informáticos que apoyen el desarrollo de las actividades y procesos"
    ]
  },
  {
    id: 12,
    color: '#a98188',
    title: "Principio 12. - Implementar Actividades de Control.",
    items: [
       // { label: "Programa de Trabajo de Administración de Riesgos (PTAR).", url: "/micro/principio7/PTAR 2026 PRESENTAR.pdf" },
      // "Actividades de Control.",
      // "Lineamientos para el establecimiento del plan de recuperación por desastres y continuidad de las operaciones para los sistemas informáticos"
    ]
  }
];

const ActividadesControl = () => {
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const toggleAccordion = (id) => {
    setExpandedId(prev => (prev === id ? null : id));
  };

  return (
    <>
      <HeaderSCI title="COMPONENTES DEL CONTROL INTERNO" />

      <div className="container ci-nav pt-4">
        {/* Title pill */}
        <div className="row justify-content-center mb-4">
          <div className="col-12 col-md-5 d-flex justify-content-center">
            <div className="ci-nav__btn--pill" style={{ cursor: 'default', margin: 0 }}>
              Actividades de Control
            </div>
          </div>
        </div>

        {/* Text Description */}
        <div className="row justify-content-center mb-5">
          <div className="col-12 col-md-10">
            <p className="ci-desc-text">
              Son aquellas acciones establecidas, a través de políticas y procedimientos, por los responsables de las unidades administrativas para alcanzar los objetivos institucionales y responder a sus riesgos asociados, incluidos los de corrupción y los de sistemas de información.
            </p>
          </div>
        </div>

        {/* Accordion / Toggle List */}
        <div className="row justify-content-center">
          <div className="col-12 col-md-10">
            {principios.map((prin) => {


              const isExpanded = expandedId === prin.id;

              return (
                <div key={prin.id} className="mb-2">
                  {/* Header Button */}
                  <div 
                    className="ci-nav__btn ci-nav__btn--doc" 
                    onClick={() => toggleAccordion(prin.id)}
                    style={{ cursor: 'pointer', padding: '8px 12px' }}
                  >
                    <div className="ci-nav__icon" style={{ backgroundColor: prin.color }}>
                      <i className="fa-solid fa-id-card"></i>
                    </div>
                    <span className="ci-nav__label ci-nav__label--doc" style={{ fontSize: '1rem', color: '#621132' }}>
                      {prin.title}
                    </span>
                  </div>

                  {/* Expanded Content */}
                  <div className={`ci-accordion-wrapper ${isExpanded ? 'is-open' : ''}`}>
                    <div className="ci-accordion-inner">
                      {prin.items.length > 0 ? (
                        <div className="ci-accordion-content ps-5 mt-1 mb-2">
                          <ul style={{ color: prin.color, fontSize: '0.95rem', fontStyle: 'italic', lineHeight: '1.6' }}>
                            {prin.items.map((item, idx) => (
                              <li key={idx} className="mb-2">
                                <a href="#" style={{ color: '#621132' }}>{item}</a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ) : (
                        <div className="ci-accordion-content ps-5 mt-1 mb-2">
                          <p style={{ color: '#621132', fontSize: '0.95rem', fontStyle: 'italic' }}>
                            No hay documentos disponibles.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default ActividadesControl;
